var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c(
        "b-col",
        { staticClass: "cs-category-title d-flex", attrs: { md: "10" } },
        [
          _c("h3", [
            _c("b", [_vm._v("Partners: ")]),
            _vm._v(_vm._s(_vm.companyName)),
          ]),
          _vm._v(" "),
          _c(
            "b-button",
            {
              staticClass: "cs-plain-btn ml-4",
              attrs: {
                to: { name: "Active", params: { partnerId: _vm.partnerId } },
              },
            },
            [_c("b-icon-arrow-left"), _vm._v(" Back to All")],
            1
          ),
        ],
        1
      ),
      _c("b-tabs", {
        staticClass: "tab-container",
        scopedSlots: _vm._u([
          {
            key: "tabs-end",
            fn: function () {
              return [
                _c(
                  "b-nav-item",
                  {
                    staticClass: "cs-nav-item-inner",
                    attrs: {
                      href: "#",
                      role: "Queue",
                      to: {
                        name: "Syndicated Queue",
                        params: { partnerId: _vm.partnerId },
                      },
                    },
                    on: {
                      click: function ($event) {
                        return _vm.setActiveParent()
                      },
                    },
                  },
                  [_c("h5", [_vm._v("Queue")])]
                ),
                _c(
                  "b-nav-item",
                  {
                    staticClass: "cs-nav-item-inner",
                    attrs: {
                      href: "#",
                      role: "Currently Live",
                      to: {
                        name: "Syndicated Live",
                        params: { partnerId: _vm.partnerId },
                      },
                    },
                    on: {
                      click: function ($event) {
                        return _vm.setActiveParent()
                      },
                    },
                  },
                  [_c("h5", [_vm._v("Currently Live")])]
                ),
                _c(
                  "b-nav-item",
                  {
                    staticClass: "cs-nav-item-inner",
                    attrs: {
                      href: "#",
                      role: "No Longer Live",
                      to: {
                        name: "Syndicated Finished",
                        params: { partnerId: _vm.partnerId },
                      },
                    },
                    on: {
                      click: function ($event) {
                        return _vm.setActiveParent()
                      },
                    },
                  },
                  [_c("h5", [_vm._v("No Longer Live")])]
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c("div", { staticClass: "w-100" }),
      _c("FilterBarPartnerSyndication", { attrs: { id: "cs-bar-filter" } }),
      _c(
        "b-container",
        {
          staticStyle: { "background-color": "#F1F2F2" },
          attrs: { fluid: "" },
        },
        [
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { staticClass: "mb-3 p-0" },
                [
                  _c(
                    "b-card",
                    {
                      staticClass: "cs-card-container",
                      attrs: { "no-body": "" },
                    },
                    [
                      _c(
                        "b-card-body",
                        { staticClass: "p-0" },
                        [_c("router-view", { attrs: { user: _vm.user } })],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }